import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";
import { TeamIdentity } from "../components/TeamIdentity";
import { fetchGame } from "../lib/api";
import { formatDate, formatLine, formatNumber } from "../lib/format";
import type { ProductGame } from "../types/product";

export function GameDetailPage() {
  const { gameId } = useParams();
  const [game, setGame] = useState<ProductGame | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!gameId) return;
    fetchGame(gameId).then(setGame).catch((err: Error) => setError(err.message));
  }, [gameId]);

  if (error) return <div className="empty-state error">{error}</div>;
  if (!game) return <div className="empty-state">Loading game…</div>;

  return (
    <div className="page-stack">
      <Link className="back-link" to="/games">
        ← Games
      </Link>

      <section className="client-scoreboard">
        <TeamIdentity
          abbr={game.game.away_team_abbr}
          name={game.game.away_team}
          score={game.halftime.away_score}
          side="away"
        />

        <div className="client-score-center">
          <span>HALFTIME</span>
          <strong>
            {game.halftime.away_score} - {game.halftime.home_score}
          </strong>
          <small>
            Week {game.game.week} · {formatDate(game.game.game_date_utc)}
          </small>
        </div>

        <TeamIdentity
          abbr={game.game.home_team_abbr}
          name={game.game.home_team}
          score={game.halftime.home_score}
          side="home"
        />
      </section>

      <section className="client-context">
        <div>
          <span>Pregame home spread</span>
          <strong>{formatLine(game.pregame.spread_home)}</strong>
        </div>
        <div>
          <span>Pregame total</span>
          <strong>{formatNumber(game.pregame.total)}</strong>
        </div>
        <div>
          <span>2H kickoff</span>
          <strong>{game.halftime.second_half_kickoff_team ?? "—"}</strong>
        </div>
      </section>

      <section className="client-replay-cta">
        <div>
          <span>HALFTIME REPLAY</span>
          <strong>See the prediction and result.</strong>
        </div>
        <Link to="/">Open replay →</Link>
      </section>
    </div>
  );
}
